import { HTTP } from '../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { httpError } from '../../models/httpError';
import { getField, updateField } from 'vuex-map-fields';
import { DealerInterest } from '@/models/dealerPortal/DealerInterest';
import { DealerManager } from '@/models/dealerPortal/DealerManager';
import output from '@/store/modules/register/output';
const state = {
  interest: new DealerInterest(),
  manager: new DealerManager(),
  rows: [],
  message: new httpError(),
};

const getters = {
  isApproved: state => {
    state.manager.isApproved;
  },
  getField,
};

const actions = {
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
  approveDealerByID({ commit, dispatch, state }, dealerID) {
    return new Promise((resolve, reject) => {
      const index = state.rows.findIndex(x => x.id === dealerID);

      let dealer = state.rows[index];

      commit('approve', index);
      dispatch('approveDealer', dealer);
    });
  },
  approveDealer({ commit, dispatch, state }, dealer) {
    return new Promise((resolve, reject) => {
      dispatch('saveDealerInterest', dealer)
        .then(data => {
          HTTP.post('DealerPortal/SendWelcomeEmail', data)
            .then(res => {
              HTTP.post('DealerPortal/UpdateSalesForce/Signing', data).then(
                res => {
                  resolve(res.data);
                }
              );
            })
            .catch(err => {
              dispatch(
                'setMessage',
                new httpError({
                  message: 'Unable to send Welcome Email: ' + err.message,
                  httpError: 500,
                })
              );
              reject(err);
            });
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'unable to save: ' + err.message,
              httpError: 500,
            })
          );
          reject(err);
        });
    });
  },
  rejectDealer({ commit, dispatch, state }, dealerID) {
    return new Promise((resolve, reject) => {
      let index = state.rows.findIndex(x => x.id === dealerID);
      let dealer = state.rows[index];
      dealer.relationShipStatus = 'Rejected';
      if (index > -1) {
        commit('rejectDealer', index);
        dispatch('saveDealerInterest', dealer)
          .then(() => {
            resolve();
          })
          .catch(err => {
            dispatch(
              'setMessage',
              new httpError({
                message: 'unable to save: ' + err.message,
                httpError: 500,
              })
            );
            reject(err.message);
          });
      } else reject("Can't find dealer");
    });
  },
  getInterested({ commit, dispatch }, showRejected) {
    return new Promise((resolve, reject) => {
      dispatch('orders/resetOrder', {}, { root: true });
      HTTP.get('DealerPortal/GetInterested/' + showRejected)
        .then(data => {
          if (data.status == 200) {
            commit('setInterested', data.data);
          } else commit('reset');
          dispatch(
            'setMessage',
            new httpError({ message: 'Retreived OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error getting Interested:' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listInterested({ dispatch }, reportParameters) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'DealerPortal/ListNewInterestSubmissions',
        reportParameters
      );
      response
        .then(data => {
          if (data.status !== 200) resolve();
          var result = data.data;
          resolve(result);
          dispatch(
            'setMessage',
            new httpError({ message: 'Retreived OK', httpStatus: 200 })
          );
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  emailInterested({ dispatch }, reportParameters) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(
        'DealerPortal/EmailNewInterestSubmissions',
        reportParameters
      );
      response
        .then(data => {
          if (data.status !== 200) resolve();
          var result = data.data;

          resolve(result);
          dispatch(
            'setMessage',
            new httpError({ message: 'Email Sent', httpStatus: 200 })
          );
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  async getRegistered({ commit, dispatch, rootState }) {
    try {
      commit('reset');
      var order = await HTTP.get('DealerPortal/GetRegisteredDealer');
      if (order.status == 200) {
        commit('setManager', order.data);
      } else {
        commit('reset', rootState.orders.dealer.dealer);
      }
      dispatch(
        'setMessage',
        new httpError({ message: 'Retreived OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error getting Data:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },

  saveDealerInterest({ dispatch }, dealerInterest) {
    return new Promise((resolve, reject) => {
      HTTP.post('DealerPortal/UpdateDealerInterest', dealerInterest)
        .then(data => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Updated OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error updating Interested:' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  saveRegistered({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      HTTP.post('DealerPortal/UpdateDealerManager/1', state.manager)
        .then(data => {
          commit('setDealer', data.data);
          dispatch(
            'setMessage',
            new httpError({ message: 'Registered', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error updating Interested:' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  listContracts(reportParameters) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.post(
          'DealerPortal/ListDealerContracts',
          reportParameters
        );
        if (response.status !== 200) resolve(response);
        var result = response.data;
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  },
  listDealerManagers(reportParameters) {
    return new Promise(async (resolve, reject) => {
      try {
        var response = await HTTP.post(
          'DealerPortal/ListDealerManagerContracts',
          reportParameters
        );
        if (response.status !== 200) resolve(response);
        var result = response.data;
        result.forEach(x => {
          x.displayText = '';
        });
        resolve(result);
      } catch (err) {
        reject(err);
      }
    });
  },
  deleteDealerInterest({ dispatch }, dealerInterest) {
    return new Promise((resolve, reject) => {
      HTTP.delete('DealerPortal/DeleteDealerInterest', { data: dealerInterest })
        .then(data => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Deleted OK', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error deleting Interested:' + err,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  sendDealerContract({ dispatch }, dealerInterest) {
    return new Promise((resolve, reject) => {
      HTTP.post('DealerPortal/SendDealerContract', dealerInterest)
        .then(data => {
          dispatch(
            'setMessage',
            new httpError({ message: 'Dealer Contract Sent!', httpStatus: 200 })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: err.response.data.message
              ? err.response.data.message
              : err.response.data,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  deleteDealerDetails({ dispatch }, ubDealerId) {
    return new Promise(async (resolve, reject) => {
      try {
        var result = await HTTP.delete(
          'DealerPortal/DeleteDealerDetails/' + ubDealerId);
        if (result.status == 200) {
          dispatch(
            'setMessage',
            new httpError({ message: 'Dealer successfully deleted', httpStatus: 200 })
          );
          resolve(true);
        }
      } catch (error) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'Error: ' + error.response.data,
            httpStatus: 500,
          })
        );
        reject(error);
      }
    });
  },
};

const mutations = {
  setDealer(state, dealer) {
    var index = state.rows.map(e => e.id).indexOf(dealer.id);
    if (index > -1) state.rows.splice(index, 1, dealer);
  },
  setInterested(state, interested) {
    state.rows = interested;
  },
  setManager(state, manager) {
    state.manager = manager;
  },
  setProgress(state, message) {
    state.message = message;
  },
  approve(state, index) {
    state.rows[index].approved = true;
    state.rows[index].rejected = false;
  },
  rejectDealer(state, index) {
    state.rows[index].approved = false;
    state.rows[index].rejected = true;
    state.rows[index].relationShipStatus = 'Rejected';
  },
  reset(state) {
    state.interest = new DealerInterest();
    state.manager = new DealerManager({});
    state.rows = [];
    state.message = new httpError();
  },
  updateField,
};

const modules = {
  output,
};

export const { mapFields: mapRegisterFields } = createHelpers({
  getterType: `register/getField`,
  mutationType: `register/updateField`,
});

export const { mapMultiRowFields: mapRegisterMultiRowFields } = createHelpers({
  getterType: 'register/getField',
  mutationType: 'register/updateField',
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
};
